<template>
    <div class="createReport">
        <LoginTip :isLogin="user && user.nickname && !iframePage" :renderData="user"/>
        <section class="topTitle bg_fff">
            <p class="fs12 co_B0">报告类型</p>
            <p class="fs14 co_333 mt8">周期性报告</p>
        </section>
        <section class="bg_fff mainBox">
            <p class="co_B0 fs12">报告主体</p>
            <mt-radio class="flex_box fs14 co_333 mt10" v-model="entity" @change="changeType"
                      :options="reportTypeOption"></mt-radio>
            <div class="noSelect fs14 mt10" @click="checkOptions(targetKey)" :class="{ noClick: !user || entity !== 'industry' }">
                <p :class="[ targetValue ? 'co_333' : 'co_B0' ]"> {{ targetValue ? targetValue : '请添加报告主体' }}</p>
                <img class="down_img" src="../assets/img/icon/iconDown.svg" alt="下拉">
            </div>


            <p class="co_B0 fs12 mt24">报告周期</p>
            <mt-radio class="flex_box fs14 co_333 mt10" v-model="reportCycle" :options="reportDateOption"></mt-radio>

            <p class="co_B0 fs12 mt24">报告时间</p>
            <div class="noSelect mt10 fs14" @click="selectDay()" :class="{ noClick: !user }">
                <p :class="[ selectedValue ? 'co_333' : 'co_B0' ]">{{ formatDay(selectedValue, reportCycle) }}{{ selectedValue ? '' : '选择报告时间' }}</p>
                <img class="down_img" src="../assets/img/icon/iconDown.svg" alt="下拉">
            </div>
        </section>

        <!--    时间选择器 & 包含日期    -->
        <div v-show="showDateBox" class="pickerPop" @touchmove.prevent>
            <!-- 年月日时分选择 -->
            <mt-datetime-picker ref="datePicker" v-model="dateVal" type="date"
                                :endDate="endDate" :startDate="startDate"
                                lockScroll="true" :visible-item-count="5" :closeOnClickModal="false"
                                year-format="{value}" month-format="{value}" date-format="{value}"
                                @cancel="showDateBox = false" @confirm="dateConfirm()">
            </mt-datetime-picker>
            <p class="fixedTitle fs14 co_333">选择日期</p>
        </div>
        <!--    时间选择器 & 不包含日期    -->
        <div v-show="showDateMouthBox" class="pickerPop pickMouthPop" @touchmove.prevent>
            <!-- 年月日时分选择 -->
            <mt-datetime-picker lockScroll="true" ref="dateMouthPicker" v-model="dateMouthVal" :visible-item-count="5"
                                :endDate="endDate" :startDate="startDate"
                                type="date" :closeOnClickModal="false" year-format="{value}" month-format="{value}"
                                @cancel="showDateMouthBox = false" @confirm="dateMouthConfirm()">
            </mt-datetime-picker>
            <p class="fixedTitle fs14 co_333">选择日期</p>
        </div>
        <section class="footControlBox mt12 co_fff text_c">
            <a v-if="user" @click="createReport" :class="(limitData && limitData.period.count < limitData.period.total) ? 'bg_blue_538': 'bg_grey_c9c'">
                <p class="fs18 font_b">生成报告</p>
                <p v-if="limitData" class="fs12 co">今日剩余可创建报告数（{{
                        limitData.period.count + '/' + limitData.period.total
                    }}）</p>
            </a>
            <a v-else @click="createReport" class="bg_blue_538 line48 pt0">
                <p class="fs18 font_b">生成报告</p>
            </a>
        </section>
        <LoadingPage :loading="loading"/>
    </div>
</template>

<script>
import moment from "moment";
import _ from "loadsh";
import _co from "../util/const";
import utils from "@/util/common";


export default {
    name: "CreateReport",
    components:{
        LoadingPage(render){ require(["@/components/common/LoadingPage"], render) },
        LoginTip(render){require(["@/components/common/LoginTip"], render)}
 },
    data() {
        return {
            loading: false,
            entity: 'industry',
            reportCycle: 'month',
            reportTypeOption: _co.reportTypeOption,
            reportDateOption: _co.reportDateOption,
            limitData: null,
            dateVal: '', // 默认是当前日期 -- 年月日
            dateMouthVal: '', // 默认是当前日期 -- 年月
            selectedValue: null, // 选中日期
            showDateBox: false, // 选择年月日弹窗
            showDateMouthBox: false, // 选择年月弹窗
            endDate: moment().toDate(),
            startDate: moment().subtract(12, 'months').startOf('year').toDate(),
            targetKey: "industries1",
            targetValue: "",
            iframePage: false,
            user: utils.getUser()
        }
    },
    created(){
        let self = this;
        window.addEventListener("popstate", function () {
            if(!self.user)
                self.$router.push({path: '/'})
        })
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            let entity = sessionStorage.getItem('entity');
            if (entity)
                this.entity = entity;

            this.resetTarget();
            let targetValue = sessionStorage.getItem(this.targetKey);
            if (targetValue) {
                this.targetValue = targetValue;
            }
            // 报告时间
            this.selectedValue = sessionStorage.getItem('smartReportTime') || null;


            if(this.user){
                this.reportCycle = "day";
                this.getReportInfo();
            } else {
                this.reportDateOption[0].disabled = true;
                this.reportTypeOption[1].disabled = true;
                this.targetValue = "银行业"
                this.selectedValue = moment("2022-10").toDate();//未登录报告显示固定时间
            }

        },
        resetDataRange(company){
            if (!this.user || !this.user.companyData || !company) {
                return;
            }

            const resetData = _.find(this.user.companyData, { name: company })
            if (resetData && resetData.dataStart) {
                if (this.startDate < moment(resetData.dataStart).toDate()) {
                    this.startDate = moment(resetData.dataStart).toDate()
                }
            }
        },
        changeType() {

            if (this.entity == "company") {
                if (this.user && this.user.mySubscribes && this.user.mySubscribes.length){
                    this.targetValue = this.user.mySubscribes[0].company;
                    this.resetDataRange(this.targetValue);
                }

                return;
            }
            sessionStorage.setItem("entity", this.entity);
            ['companies1', 'industries1', 'TimeList'].forEach(item => {
                sessionStorage.removeItem(item);
            })
            this.resetTarget();
        },
        resetTarget() {
            this.targetKey = this.entity == "industry" ? "industries1" : "companies1";
            this.targetValue = "";
        },
        formatDay(date) {
            if (!date)
                return '';

            if (this.reportCycle == 'day')
                return moment(date, 'IOS_8601').format('YYYY/MM/DD')
            else
                return moment(date).format('YYYY/MM')
        },
        async getReportInfo() { // 获取报告信息
            let data = await this.baseApi.getReportInfo()
            if (data !== 'comfirm') {
                let obj = {};
                data.list.forEach(item => {
                    obj[item.type] = {
                        total: item.total,
                        count: item.count,
                    };
                })
                this.limitData = obj;
            }
        },
        checkOptions(pageType) {
            let query = {pageType: pageType}
            if (pageType === 'timeList') {
                query.custom = 'custom';
            } else {
                query.entity = this.targetValue;
            }
            this.$router.push({path: '/optionsPage', query})
        },
        // 时间选择器相关
        selectDay() {
            let date = this.selectedValue ? new Date(this.selectedValue) : new Date(this.endDate);
            if (this.reportCycle == 'day') {
                this.dateVal = date;
                this.$refs['datePicker'].open()
                this.showDateBox = true;
                return;
            }
            this.dateMouthVal = date;
            this.$refs['dateMouthPicker'].open()
            this.showDateMouthBox = true;

        },
        // 时间选择器确定按钮
        dateConfirm() {
            this.selectedValue = this.dateVal;
            sessionStorage.setItem('smartReportTime', this.dateVal);
            this.showDateBox = false;
        },
        dateMouthConfirm() {
            this.selectedValue = this.dateMouthVal;
            sessionStorage.setItem('smartReportTime', this.dateMouthVal);
            this.showDateMouthBox = false;
        },
        async createReport() { // 创建报告
            if(!this.user){
                this.$router.push(`/reports/${_co.defaultReportId}?title=2022年10月%20银行业月报`);
                return ;
            }
            if(this.limitData.period.count >= this.limitData.period.total){
                return ;
            }

            if (!this.targetValue) {
                this.$messagebox({
                    title: '',
                    message: '请选择报告主体',
                });
                return
            }
            if (!this.selectedValue) {
                this.$messagebox({
                    title: '',
                    message: '请选择报告时间',
                });
                return
            }
            if (this.loading) {
                return
            }
            this.loading = true;
            let startTime = moment(this.selectedValue, 'IOS_8601').startOf(this.reportCycle).valueOf()
            let endTime = moment(this.selectedValue, 'IOS_8601').endOf(this.reportCycle).valueOf()

            await this.baseApi.createReport({
                entityType: this.entity,
                entityId: this.entity == "industry" ? _co.industryLabelMap[this.targetValue] : this.targetValue,
                type: 'period', // 'event' | 'period' | 'expert'
                period: this.reportCycle, // 'day' | 'week' | 'month' | 'year'
                startTime, endTime
            })
            this.loading = false;
            this.$messagebox({
                title: '',
                message: '报告生成中，请稍后...<br/>您可前往报告页面查看进度'
            }).then(()=>{
                this.getReportInfo()
                this.$router.replace({path: '/reports'})
            })

        },
    }
}
</script>

<style lang="scss" scoped>
.createReport {
    .topTitle {
        padding: 16px;
    }

    .mainBox {
        width: calc(100vw - 32px);
        margin: 8px auto;
        padding: 16px 16px 32px;
        border-radius: 4px;

        .mt24 {
            margin-top: 24px;
        }

        .radioBox {
            input {
                width: 18px;
                height: 18px;
            }
        }

        .noSelect {
            height: 40px;
            line-height: 40px;
            border: 1px solid #C9C9CA;
            border-radius: 2px;
            position: relative;
            text-indent: 8px;

            img {
                width: 16px;
                position: absolute;
                top: 12px;
                right: 8px;
            }
        }

        .selectBox {
            span {
                margin: 0 9px;
            }
        }
    }

    .pickerPop {
        width: 100%;
        height: 260px;
        position: fixed;
        bottom: 0;
        z-index: 10;

        .fixedTitle {
            position: absolute;
            top: 16px;
            left: 16px;
            z-index: 200000;
        }
    }

    .footControlBox {
        width: 100%;
        height: 48px;

        a {
            width: 100%;
            height: 48px;
            position: fixed;
            bottom: 0;
            left: 0;
            //background-color: #538DFF;
            padding-top: 3px;
        }
    }

    .noClick {
        pointer-events: none;
        background-color: rgba(245, 246, 248, 1);

        .down_img {
            display: none;
        }
    }
}
</style>